export default "__VITE_ASSET__D1s26tkQ__"